module.exports = __webpack_public_path__ + "img/tzav.0fcda2bb.svg";